import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setFilter as setStateFilter } from "../../actions/overview";
import { WrapInDialogButton } from "../WrapInDialogButton";

// const searchStudentContact = useSearchComponent({
//     name: "Cursist",                             // The title
//     columnIdentifier: "uuid",                    // The column to select from the results
//     resultColumnIdentifier: "student",           // The value to store/return it to
//     identifier: "course-filter",                 // The filter group identifier
//     Component: <SearchStudent />,                // The component to be used
//     resultDef: props => `${props.full_name} (${props.nibhv_number})`,    // How the resul must look for the user
// });

// Creates a button with a Component to be used for selecting the content
export function useSearchComponent(props) {
    const [result, setResult] = useState(false);

    const dispatch = useDispatch();

    const setFilter = (val) => {
        if (!val) {
            setResult(false);
        }
        dispatch(
            setStateFilter(props.identifier, {
                columnIdentifier: props.columnIdentifier,
                value: val
            })
        );
    };

    const content = (
        <WrapInDialogButton
            buttonTitle={props?.title || "Zoek"}
            dialogTitle={props?.title || "Zoek"}
            icon={props?.icon}
            className={"btn-search btn"}
            onClick={(params) => {
                setResult(params);
                setFilter(params[props.columnIdentifier]);
            }}
        >
            {props.Component}
        </WrapInDialogButton>
    );

    return {
        content,
        resultObj: {
            columnIdentifier: props?.resultColumnIdentifier ? props.resultColumnIdentifier : props.columnIdentifier,
            result: result[props.columnIdentifier]
        },
        result: result ? (props?.resultDef ? props.resultDef(result) : result[props.columnIdentifier]) : false,
        name: props?.name || "Geen naam opgegeven",
        reset: () => setFilter(""),
        setResult: (o) => setFilter(o)
    };
}
